export const VITRINS_OFFERS_TEXTS = {
  TITLE: 'Ещё предложения от банков',
};
